// src/utils/datadog.ts
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { createBaseURL } from './axios';

const currentEnv = import.meta.env.VITE_ENV as keyof typeof createBaseURL;
const apiBaseUrl = createBaseURL[currentEnv];

export const initializeDatadog = () => {
  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'dpost_portal',
    env: import.meta.env.VITE_DATADOG_ENV || 'prod',
    version: __APP_VERSION__ || '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [apiBaseUrl],
    useSecureSessionCookie: true,
    sessionPersistence: ['cookie', 'local-storage'],
    trackAnonymousUser: false, // 쿠키 15분만 유지
  });

  datadogRum.startSessionReplayRecording();

  datadogLogs.init({
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'dpost_portal',
    env: import.meta.env.VITE_DATADOG_ENV || 'prod',
    version: __APP_VERSION__ || '1.0.0',
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error'],
    sessionSampleRate: 100,
    sessionPersistence: ['cookie', 'local-storage'],
  });
};
